export default __webpack_public_path__ + "static/media/partner14.ac8d81d4.webp";